import "./App.css";
import "flag-icons/css/flag-icons.min.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import GeneralPage from "./components/pages/General";
import MembersPage from "./components/pages/Members";
import TeamsPage from "./components/pages/TeamsPage";
import IntegrationsPage from "./components/pages/IntegrationsPage";
import SecurityPage from "./components/pages/Security";
import DashboardPage from "./components/pages/Dashboard";
import NewWorkspacePage from "./components/pages/NewWorkspace";
import PageNotFoundPage from "./components/pages/PageNotFound";
import Workspaces from "./components/pages/Workspaces";
import TeamDetailsPage from "./components/pages/TeamDetailsPage";
import EnrichListPage from "./components/pages/EnrichList";
import EnrichListDetailsPage from "./components/pages/EnrichListDetailsPage";
import CreditConsumptionLogPage from "./components/pages/CreditConsumptionLog";
import ToastContainer from "./components/ToastContainer";
import EnrichCompanyPage from "./components/pages/EnrichCompany";
import EnrichPeoplePage from "./components/pages/EnrichPeople";
import CompanyPage from "./components/pages/Company";
import ContactPage from "./components/pages/Contact";
import Login from "./components/pages/Login";
import Register from "./components/pages/Register";
import Onboarding from "./components/pages/Onboarding";
import PrivateRoute from "./PrivateRoute";
import ForgetPassword from "./components/pages/ForgetPassword";
import CrmMapping from "./components/containers/Integrations/CRM/CrmMapping";
import AcceptInvite from "./components/pages/AcceptInvite";
import Logout from "./components/pages/Logout";
import Profile from "./components/pages/Profile";
import ApiKeysPage from "./components/pages/ApiKeys";
import { Helmet } from "react-helmet";
import OffBoarding from "./components/pages/Offboarding";
import ScoringPage from "./components/pages/Scoring";
import CallLogsPage from "./components/pages/CallLogs";
import CallDetailsPage from "./components/pages/CallDetails";
import DialerPage from "./components/pages/Dialer/index";
import PhoneInventoryPage from "./components/pages/PhoneInventory";
import PhoneNumberSettingsPage from "./components/pages/PhoneNumberSettings";
import DialerAIPage from "./components/pages/DialerAI";
import AddDialerUserPage from "./components/pages/AddDialerUser";

import CompaniesPage from "./components/pages/Companies";
import ContactListOfCompany from "./components/pages/ContactListOfCompany";
import ContactListOfCompanyToCrm from "./components/pages/ContactListOfCompanyToCrm";
import ScoringPersonaPage from "./components/pages/ScoringPersona";
import ContactViewerPage from "./routes/ContactViewer";
import CompanyDetails from "./components/pages/CompanyDetails";
import ContactsPage from "./components/pages/Contacts";
import CompanyListOfCrm from "./components/pages/CompanyListOfCrm";
import CoachAIPage from "./components/pages/CoachAI";
import CoachAISessionReportPage from "./components/pages/CoachAI/SessionReport";
import SubscriptionsPage from "./components/pages/Billing/Subscriptions";
import PlansPage from "./components/pages/Billing/Plans";
import UsagePage from "./components/pages/Billing/Usage";
import AnalyticsPage from "./components/pages/Analytics";
import CustomFieldsPage from "./components/pages/CustomFields";

function App() {
  return (
    <Router basename={`/${process.env.REACT_APP_APP_HOME}`}>
      <Routes>
        <Route
          path="/reset-password"
          element={
            <>
              <Helmet>
                <title>Reset Your Password - {process.env.REACT_APP_APP_NAME}</title>
              </Helmet>
              <ForgetPassword />
            </>
          }
        />
        <Route
          path="/login"
          element={
            <>
              <Helmet>
                <title>Login to Your Account - {process.env.REACT_APP_APP_NAME}</title>
              </Helmet>
              <Login />
            </>
          }
        />
        <Route
          path="/register"
          element={
            <>
              <Helmet>
                <title>Create an Account - {process.env.REACT_APP_APP_NAME}</title>
              </Helmet>
              <Register />
            </>
          }
        />
        <Route
          path="/invitation/accept/:inviteId/:inviteToken"
          element={
            <>
              <Helmet>
                <title>Accept Your Invitation - {process.env.REACT_APP_APP_NAME}</title>
              </Helmet>
              <AcceptInvite />
            </>
          }
        />
        <Route
          path="/logout"
          element={
            <>
              <Helmet>
                <title>Logging Out - {process.env.REACT_APP_APP_NAME}</title>
              </Helmet>
              <Logout />
            </>
          }
        />
        <Route
          path="/chrome-extension-offboarding"
          element={
            <>
              <Helmet>
                <title>Sad to see you go!</title>
              </Helmet>
              <OffBoarding />
            </>
          }
        />

        <Route path="/" element={<PrivateRoute />}>
          <Route
            exact
            path="/:workspaceSlug/"
            element={
              <>
                <Helmet>
                  <title>Dashboard - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <DashboardPage />
              </>
            }
          />
          <Route
            exact
            path="/workspaces"
            element={
              <>
                <Helmet>
                  <title>Your Workspaces - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <Workspaces />
              </>
            }
          />
          <Route
            path="/onboarding"
            element={
              <>
                <Helmet>
                  <title>Get Started with {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <Onboarding />
              </>
            }
          />

          <Route
            exact
            path="/:workspaceSlug/settings/general"
            element={
              <>
                <Helmet>
                  <title>General settings - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <GeneralPage />
              </>
            }
          />
          <Route
            path="/:workspaceSlug/settings/members"
            element={
              <>
                <Helmet>
                  <title>Manage members - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <MembersPage />
              </>
            }
          />
          <Route
            path="/:workspaceSlug/settings/members/requests"
            element={
              <>
                <Helmet>
                  <title>Member Requests - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <MembersPage />
              </>
            }
          />
          <Route
            path="/:workspaceSlug/settings/members/invitations"
            element={
              <>
                <Helmet>
                  <title>Member Invitations - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <MembersPage />
              </>
            }
          />
          <Route
            path="/:workspaceSlug/settings/billing/subscriptions"
            element={
              <>
                <Helmet>
                  <title>Billing: Subscriptions - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <SubscriptionsPage />
              </>
            }
          />
          <Route
            path="/:workspaceSlug/settings/billing/plans"
            element={
              <>
                <Helmet>
                  <title>Billing: Plans - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <PlansPage />
              </>
            }
          />
          <Route
            path="/:workspaceSlug/settings/billing/usage"
            element={
              <>
                <Helmet>
                  <title>Billing: Usage - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <UsagePage />
              </>
            }
          />
          <Route
            path="/:workspaceSlug/settings/teams"
            element={
              <>
                <Helmet>
                  <title>Teams setting - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <TeamsPage />
              </>
            }
          />
          <Route
            path="/:workspaceSlug/settings/teams/:teamId"
            element={
              <>
                <Helmet>
                  <title>Team Details - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <TeamDetailsPage />
              </>
            }
          />
          <Route
            path="/:workspaceSlug/settings/integrations"
            element={
              <>
                <Helmet>
                  <title>Integrations - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <IntegrationsPage />
              </>
            }
          />

          <Route
            path="/:workspaceSlug/settings/integrations/:crmKey/:crmConfigId/"
            element={
              <>
                <Helmet>
                  <title>CRM settings - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <CrmMapping />
              </>
            }
          />
          <Route
            path="/:workspaceSlug/settings/security"
            element={
              <>
                <Helmet>
                  <title>Security settings - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <SecurityPage />
              </>
            }
          />
          <Route
            path="/:workspaceSlug/settings/api-keys"
            element={
              <>
                <Helmet>
                  <title>API Keys - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <ApiKeysPage />
              </>
            }
          />
          <Route
            path="/:workspaceSlug/settings/usage-analytics"
            element={
              <>
                <Helmet>
                  <title>Usage Analytics - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <CreditConsumptionLogPage />
              </>
            }
          />
          <Route
            path="/:workspaceSlug/dialer-ai"
            element={
              <>
                <Helmet>
                  <title>Dialer & AI Settings - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <DialerAIPage />
              </>
            }
          />
          <Route
            path="/:workspaceSlug/dialer-ai/add-user"
            element={
              <>
                <Helmet>
                  <title>Add User - Dialer Settings - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <AddDialerUserPage />
              </>
            }
          />

          <Route
            path="/:workspaceSlug/intelligence/scoring"
            element={
              <>
                <Helmet>
                  <title>Scoring - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <ScoringPage />
              </>
            }
          />
          {/* <Route
            path="/:workspaceSlug/intelligence/scoring/custom-fields"
            element={
              <>
                <Helmet>
                  <title>Custom Fields - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <CustomFieldsPage />
              </>
            }
          /> */}
          <Route
            path="/:workspaceSlug/intelligence/scoring/persona"
            element={
              <>
                <Helmet>
                  <title>Scoring Persona - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <ScoringPersonaPage />
              </>
            }
          />
          <Route
            path="/:workspaceSlug/coach-ai"
            element={
              <>
                <Helmet>
                  <title>Coach AI - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <CoachAIPage />
              </>
            }
          />
          <Route
            path="/:workspaceSlug/coach-ai/session/:sessionId"
            element={
              <>
                <Helmet>
                  <title>Coach AI Session Report - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <CoachAISessionReportPage />
              </>
            }
          />
          <Route
            path="/:workspaceSlug/call-logs"
            element={
              <>
                <Helmet>
                  <title>Call Recordings - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <CallLogsPage />
              </>
            }
          />
          <Route
            path="/:workspaceSlug/call-logs/:callId"
            element={
              <>
                <Helmet>
                  <title>Call Details - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <CallDetailsPage />
              </>
            }
          />

          <Route
            path="/:workspaceSlug/dialer"
            element={
              <>
                <Helmet>
                  <title>Dialer - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <DialerPage />
              </>
            }
          />

          <Route
            path="/:workspaceSlug/numbers-inventory"
            element={
              <>
                <Helmet>
                  <title>Numbers Inventory - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <PhoneInventoryPage />
              </>
            }
          />

          <Route
            path="/:workspaceSlug/numbers-inventory/:phoneId/settings"
            element={
              <>
                <Helmet>
                  <title>Phone Number Settings - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <PhoneNumberSettingsPage />
              </>
            }
          />

          <Route
            path="/:workspaceSlug/activity"
            element={
              <>
                <Helmet>
                  <title>Call Activity - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <AnalyticsPage />
              </>
            }
          />

          <Route
            path="/:workspaceSlug/enrich/list"
            element={
              <>
                <Helmet>
                  <title>Enrichment List - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <EnrichListPage />
              </>
            }
          />
          {/* <Route path="/:workspaceSlug/enrich/company" element={<EnrichCompanyPage />} />
          <Route path="/:workspaceSlug/enrich/company/:companyId" element={<CompanyPage />} /> */}
          <Route
            path="/:workspaceSlug/enrich/people"
            element={
              <>
                <Helmet>
                  <title>Enrich People - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <EnrichPeoplePage />
              </>
            }
          />
          {/* <Route path="/:workspaceSlug/enrich/people/:contactId" element={<ContactPage />} /> */}
          <Route
            path="/:workspaceSlug/enrich/list/:enrichListId"
            element={
              <>
                <Helmet>
                  <title>Enrichment Details - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <EnrichListDetailsPage />
              </>
            }
          />

          <Route
            path="/create-workspace"
            element={
              <>
                <Helmet>
                  <title>Create a New Workspace - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <NewWorkspacePage />
              </>
            }
          />
          <Route
            path="/profile"
            element={
              <>
                <Helmet>
                  <title>Your Profile - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <Profile />
              </>
            }
          />
          {/* <Route
            path="/:workspaceSlug/companies"
            element={
              <>
                <Helmet>
                  <title>Companies - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <CompaniesPage />
              </>
            }
          /> */}
          {/* <Route
            path="/:workspaceSlug/contacts"
            element={
              <>
                <Helmet>
                  <title>Contacts - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <ContactsPage />
              </>
            }
          /> */}
          {/* <Route
            path="/:workspaceSlug/companies/:companyId"
            element={
              <>
                <Helmet>
                  <title>Company - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <CompanyDetails />
              </>
            }
          /> */}
          {/* <Route
            path="/:workspaceSlug/company-contact-list"
            element={
              <>
                <Helmet>
                  <title>Companies - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <ContactListOfCompany />
              </>
            }
          /> */}

          <Route
            path="/:workspaceSlug/company-list/push-to-crm"
            element={
              <>
                <Helmet>
                  <title>Companies - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <CompanyListOfCrm />
              </>
            }
          />
          <Route
            path="/:workspaceSlug/company-contact-list/push-to-crm"
            element={
              <>
                <Helmet>
                  <title>Companies - {process.env.REACT_APP_APP_NAME}</title>
                </Helmet>
                <ContactListOfCompanyToCrm />
              </>
            }
          />
        </Route>
        <Route path="/contact-viewer/*" element={<ContactViewerPage />} />

        <Route
          path="*"
          element={
            <>
              <Helmet>
                <title>Page Not Found - {process.env.REACT_APP_APP_NAME}</title>
              </Helmet>
              <PageNotFoundPage />
            </>
          }
        />
      </Routes>
      <ToastContainer />
    </Router>
  );
}

export default App;